import commonJs from "../../../assets/js/common/common.js";
import manAudit from "../pages/accountAudit/manAudit";
import userAudit from "../pages/accountAudit/userAudit";
import carryAudit from "../pages/accountAudit/carryAudit";

import authorityApply from "../pages/authorityApply/authorityApply";
import businessManage from "../pages/businessConfig/businessManage";

import contentAudit from "../pages/contentManage/contentAudit";
import contentFeedback from "../pages/contentManage/contentFeedback";
import contentFeedbackAudit from "../pages/contentManage/contentFeedbackAudit";
import content from "../pages/contentManage/contentAudit/contentAudit.vue";
import taskContent from "../pages/contentManage/taskContentAudit/taskContentAudit.vue";
import circleManage from "../pages/contentManage/circleManage/circleManage.vue";
import circlePostManage from "../pages/contentManage/circlePostManage/circlePostManage.vue";
import transportManage from "../pages/transportManage/transprotManage.vue";
import transportPostManage from "../pages/transportPostManage/transprotPostManage.vue";
import transportContentManage from "../pages/transportContentManage/transprotContentManage.vue";
import transportContentAutoManage from "../pages/transportContentAutoManage/transportContentAutoManage.vue";
import contentEdit from "../pages/article/index";
import patientCase from "../pages/contentManage/patientCase/patientCase.vue";
import patientCaseDetail from "../pages/contentManage/patientCaseDetail/patientCaseDetail.vue";
import advertPost from "../pages/contentManage/circleManage/advertPost.vue";
// import contentEdit from '../../../components/article'

// 百科页
import wiki from "../pages/wikiManage/wiki";
import wikiList from "../pages/wikiManage/wiki/wikiList";
import symptomList from "../pages/wikiManage/symptom/symptomList";
// import symptom from "../pages/symptom";
import symptom from "../../../components/symptom";
import disease from "../pages/disease";

import commonLabel from "../pages/labelManage/commonLabel";
import labelGroup from "../pages/labelManage/commonLabel/labelGroup";
// import firstLabel from "../pages/labelManage/commonLabel/firstLabel";
const firstLabel = () => import("../pages/labelManage/commonLabel/firstLabel");
import secondLabel from "../pages/labelManage/commonLabel/seconLabel";
import threeLabel from "../pages/labelManage/commonLabel/threeLabel";

import customLabel from "../pages/labelManage/customLabel";
import customerGroup from "../pages/labelManage/customLabel/customerGroup";
const cusFirst = () => import("../pages/labelManage/customLabel/cusFirst");
// import cusFirst from "../pages/labelManage/customLabel/cusFirst";
import cusSecond from "../pages/labelManage/customLabel/cusSecond";
import cusThree from "../pages/labelManage/customLabel/cusThree";

import partLabel from "../pages/labelManage/partLabel";
import partGroup from "../pages/labelManage/partLabel/partGroup";

import categoryManage from "../pages/businessConfig/categoryManage";
import category from "../pages/businessConfig/categoryManage/category";
import channels from "../pages/businessConfig/categoryManage/channels";

import roleManage from "../pages/roleManage/roleManage";
import logo from "../../../components/logo.vue";

import index from "../pages/index/index";
import man from "../pages/man";
import contentTool from "../pages/contentTool";
import contentRepeat from "../pages/contentTool/contentRepeat";
import contentRecord from "../pages/contentTool/contentRecord";
import contentRepeatDetail from "../pages/contentTool/contentRepeatDetail";
import contentSensitiveWord from "../pages/contentTool/contentSensitiveWord";

// 评论管理;
import evaluation from "../pages/evaluation/evaluation";
// 医生自动回复;
import doctorAutoReply from "../pages/doctorAutoReply";
// 医学中心
import liveManage from "../pages/liveManage";
import liveList from "../pages/liveManage/liveList";

// 问答库
// import questions from "../pages/questionsLibrary/questions";
// import questionBuild from "../pages/questionsLibrary/questionsPage/questionBuild"
// import questionEdit from "../pages/questionsLibrary/questionsPage/questionEdit";
// 新版问答库
import questionList from "../pages/questionAnswer/questionList";
import questionEdit from "../pages/questionAnswer/questionEdit";
import answerList from "../pages/questionAnswer/answerList";
import answerEdit from "../pages/questionAnswer/answerEdit";
import emptyRouter from "../pages/emptyRouter";
// 内容分发
import contentDistribution from "../pages/contentManage/contentDistribution/contentDistribution";
import contentDistributionArticle from "../pages/contentManage/contentDistribution/contentDistributionArticle";
import BusinessPage from "../pages/contentManage/businessContent/BusinessPage";
// 药品百科
import encyclopediaMan from "../pages/wikiManage/encyclopediaMedicine/index";
import encyclopediaEdit from "../pages/wikiManage/encyclopediaMedicine/encyclopediaEdit";
// 疫苗百科
import vaccines from "../pages/wikiManage/vaccines";
import vaccineList from "../pages/wikiManage/vaccines/list";
import healthcare from "../pages/wikiManage/healthcare";
import healthcareList from "../pages/wikiManage/healthcare/list";
import commonwikiEdit from "../pages/wikiManage/commonwiki";
import commonwikiList from "../pages/wikiManage/commonwiki/list";

// 谣言
import rumorManage from "../pages/rumorManage/rumorManage.vue";
import rumorList from "../pages/rumorManage/rumorList.vue";

// 专业问答管理
import pgcManage from "../pages/pgcManage/pgcManage.vue";
import pgcQa from "../pages/pgcManage/pgcQa.vue";
import pgcQaDetail from "../pages/pgcManage/pgcQaDetail.vue";
import editQas from "../pages/pgcManage/editQas.vue";
import pgcImport from "../pages/pgcManage/pgcImport.vue";
import pgcExport from "../pages/pgcManage/pgcExport.vue";
import pgcDelete from "../pages/pgcManage/pgcDelete.vue";
import pcdImport from "../pages/patientCase/import.vue";
import pcdExport from "../pages/patientCase/export.vue";
import pcdDelete from "../pages/patientCase/delete.vue";
import pgcRecord from "../pages/pgcManage/pgcRecord.vue";
import featuredManage from "../pages/contentManage/featuredManage/index.vue";
import dailyFeatured from "../pages/contentManage/dailyFeatured/index.vue";
import postMarkLabel from "../pages/contentManage/postMarkLabel/circlePostManage.vue";
import postLabelManage from "../pages/postLabelManage/index.vue";
import postEventCateManage from "../pages/postEvent/postEventCateManage/index.vue";
import postEventManage from "../pages/postEvent/postEventManage/index.vue";
import eventPostManage from "../pages/contentManage/eventPostManage/index.vue";
import complaint from "../pages/complaint/index.vue";
import blackList from "../pages/blackList/index.vue";
import topManage from "../pages/contentManage/topManage/index.vue";
import messageManage from "../pages/messageManage/index.vue";

// 帖子
import topicManage from "../pages/topicManage/topicManage.vue";
import topicRecommand from "../pages/topicRecommand/topicRecommand.vue";
import topicHot from "../pages/topicHot/topicHot.vue";


// 524 热榜
import hotBrand524 from "../pages/hotBrand524/hotBrand524.vue";
/*const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};*/

import courseActivityManagement from "../pages/courseActivityManagement/index.vue";
var routes = [
  {
    path: "/categoryManage",
    redirect: "/categoryManage/category",
  },
  {
    path: "/commonLabel",
    redirect: "/commonLabel/group",
  },
  {
    path: "/customLabel",
    redirect: "/customLabel/cusGroup",
  },
  {
    path: "/partLabel",
    redirect: "/partLabel/partGroup",
  },
  {
    path: "/",
    redirect: "/index",
    component: man,
    children: [
      // 内容审核与上下线
      {
        path: "/contentAudit",
        name: "/contentAudit",
        redirect: "/contentAudit/content",
        component: contentAudit,
        meta: {
          title: "内容管理",
          isMenu: false,
        },
        children: [
          {
            path: "/contentAudit/content",
            name: "/contentAudit/content",
            component: content,
            meta: {
              title: "内容审核",
            },
          },
          {
            path: "/contentAudit/contentFeedback",
            name: "/contentAudit/contentFeedback",
            component: contentFeedback,
            meta: {
              title: "内容反馈",
            },
          },
          {
            path: "/contentAudit/contentFeedbackAudit",
            name: "/contentAudit/contentFeedbackAudit",
            component: contentFeedbackAudit,
            meta: {
              title: "内容反馈审核",
            },
          },
          {
            path: "/contentAudit/contentedit",
            name: "/contentAudit/contentedit",
            component: contentEdit,
            meta: {
              title: "文章编辑",
            },
          },
          {
            path: "/contentAudit/task",
            name: "/contentAudit/task",
            component: taskContent,
            meta: {
              title: "任务内容审核",
            },
          },
          {
            path: "/circleManage",
            name: "/circleManage",
            component: circleManage,
            meta: {
              title: "圈子管理",
            },
          },
          {
            path: "/topicManage",
            name: "/topicManage",
            component: topicManage,
            meta: {
              title: "话题管理",
              upMenuTitle: [{ title: "话题管理", url: "", isMenu: false }],
            },
          },
          {
            path: "/topicRecommand",
            name: "/topicRecommand",
            component: topicRecommand,
            meta: {
              title: "推荐话题",
              upMenuTitle: [{ title: "话题管理", url: "", isMenu: false }],
            },
          },
          {
            path: "/topicHot",
            name: "/topicHot",
            component: topicHot,
            meta: {
              title: "推荐话题",
              upMenuTitle: [{ title: "热门话题", url: "", isMenu: false }],
            },
          },
          {
            path: "/transportManage",
            name: "/transportManage",
            component: transportManage,
            meta: {
              title: "搬运管理",
            },
          },
          {
            path: "/transportPostManage",
            name: "/transportPostManage",
            component: transportPostManage,
            meta: {
              title: "帖子搬运管理",
            },
          },
          {
            path: "/transportContentManage",
            name: "/transportContentManage",
            component: transportContentManage,
            meta: {
              title: "帖子搬运管理",
            },
          },
          {
            path: "/transportContentAutoManage",
            name: "/transportContentAutoManage",
            component: transportContentAutoManage,
            meta: {
          
              title: "内容搬运管理",
            },
          },
          {
            path: "/circlePostManage",
            name: "/circlePostManage",
            component: circlePostManage,
            meta: {
              title: "帖子管理",
            },
          },
          {
            path: "/postLabelManage",
            name: "/postLabelManage",
            component: postLabelManage,
            meta: {
              title: "标签管理",
              upMenuTitle: [{ title: "帖子运营", url: "", isMenu: false }],
            },
          },
          {
            path: "/postMarkLabel",
            name: "/postMarkLabel",
            component: postMarkLabel,
            meta: {
              title: "帖子打标",
              upMenuTitle: [{ title: "帖子运营", url: "", isMenu: false }],
            },
          },
          {
            path: "/postEventCateManage",
            name: "/postEventCateManage",
            component: postEventCateManage,
            meta: {
              title: "活动分类",
              upMenuTitle: [{ title: "帖子运营", url: "", isMenu: false }],
            },
          },
          {
            path: "/postEventManage",
            name: "/postEventManage",
            component: postEventManage,
            meta: {
              title: "活动管理",
              upMenuTitle: [
                {
                  title: "活动分类",
                  url: "/postEventCateManage",
                  isMenu: true,
                },
              ],
            },
          },
          {
            path: "/eventPostManage",
            name: "/eventPostManage",
            component: eventPostManage,
            meta: {
              title: "帖子管理",
              upMenuTitle: [
                { title: "活动管理", url: "/postEventManage", isMenu: true },
              ],
            },
          },
          {
            path: "/patientCase",
            name: "/patientCase",
            component: patientCase,
            meta: {
              title: "患者案例",
            },
          },
          {
            path: "/patientCaseDetail",
            name: "/patientCaseDetail",
            component: patientCaseDetail,
            meta: {
              title: "患者案例详情",
            },
          },
          {
            path: "/patientCase/import",
            name: "/patientCase/import",
            component: pcdImport,
            meta: {
              title: "批量导入患者案例",
              isMenu: false,
            },
          },
          {
            path: "/patientCase/export",
            name: "/patientCase/export",
            component: pcdExport,
            meta: {
              title: "批量导出患者案例",
              isMenu: false,
            },
          },
          {
            path: "/patientCase/delete",
            name: "/patientCase/delete",
            component: pcdDelete,
            meta: {
              title: "批量删除患者案例",
              isMenu: false,
            },
          },
          {
            path: "/hotBrand524",
            name: "/hotBrand524",
            component: hotBrand524,
            meta: {
              title: "热榜管理",
              isMenu: false,
            },
          },
          {
            path: "/courseActivityManagement",
            name: "/courseActivityManagement",
            component: courseActivityManagement,
            meta: {
              title: "帖子运营",
              upMenuTitle: [{ title: "课程管理", url: "", isMenu: false }],
            },
          },
          {
            path: "/advertPost",
            name: "/advertPost",
            component: advertPost,
            meta: {
              title: "新增广告贴",
              upMenuTitle: [{ title: "新增广告贴", url: "", isMenu: false }],
            },
          },
        ],
      },
      {
        path: "/topManage",
        name: "/topManage",
        component: topManage,
        meta: {
          title: "置顶管理",
          upMenuTitle: [{ title: "人工干预", url: "", isMenu: false }],
        },
      },
      {
        path: "/featuredManage",
        name: "/featuredManage",
        component: featuredManage,
        meta: {
          title: "广场精选",
          upMenuTitle: [{ title: "人工干预", url: "", isMenu: false }],
        },
      },
      {
        path: "/dailyFeatured",
        name: "/dailyFeatured",
        component: dailyFeatured,
        meta: {
          title: "每日精选",
          upMenuTitle: [{ title: "人工干预", url: "", isMenu: false }],
        },
      },
      // 举报管理
      {
        path: "/complaint",
        name: "/complaint",
        component: complaint,
        meta: {
          title: "举报管理",
          upMenuTitle: [{ title: "举报管理", url: "", isMenu: false }],
        },
      },
      // 小黑屋
      {
        path: "/blackList",
        name: "/blackList",
        component: blackList,
        meta: {
          title: "小黑屋",
          upMenuTitle: [{ title: "举报管理", url: "", isMenu: false }],
        },
      },
      // 百科页
      {
        path: "/wikiManage",
        name: "/wikiManage",
        redirect: "/wikiManage/wiki",
        component: wiki,
        meta: {
          title: "百科页",
          isMenu: false,
        },
        children: [
          {
            path: "/wikiManage/wiki",
            name: "/wikiManage/wiki",
            component: wikiList,
            meta: {
              title: "百科管理",
            },
          },
          // 疾病
          {
            path: "/wikiManage/diseaseEdit",
            name: "/wikiManage/diseaseEdit",
            component: disease,
            meta: {
              title: "内容编辑",
            },
          },
          // 症状
          {
            path: "/wikiManage/symptomEdit",
            name: "/wikiManage/symptomEdit",
            component: symptom,
            meta: {
              title: "内容编辑",
            },
          },
          {
            path: "/wikiManage/symptom",
            name: "/wikiManage/symptom",
            component: symptomList,
            meta: {
              title: "症状百科",
            },
          },
          {
            path: "/wikiManage/drug",
            name: "/wikiManage/drug",
            component: encyclopediaMan,
            meta: {
              title: "药品百科",
            },
          },
          {
            path: "/wikiManage/vaccinesEdit",
            name: "/wikiManage/vaccinesEdit",
            component: vaccines,
            meta: {
              title: "内容编辑",
            },
          },
          {
            path: "/wikiManage/vaccineList",
            name: "/wikiManage/vaccineList",
            component: vaccineList,
            meta: {
              title: "疫苗百科",
            },
          },
          {
            path: "/wikiManage/healthcare",
            name: "/wikiManage/healthcare",
            component: healthcareList,
            meta: {
              title: "保健百科",
            },
          },
          {
            path: "/wikiManage/healthcareEdit",
            name: "/wikiManage/healthcareEdit",
            component: healthcare,
            meta: {
              title: "内容编辑",
            },
          },
          {
            path: "/wikiManage/commonwiki",
            name: "/wikiManage/commonwiki",
            component: commonwikiList,
            meta: {
              title: "百科",
            },
          },
          {
            path: "/wikiManage/commonwikiEdit",
            name: "/wikiManage/commonwikiEdit",
            component: commonwikiEdit,
            meta: {
              title: "内容编辑",
            },
          },
          {
            path: "/wikiManage/encyclopediaEdit",
            name: "/wikiManage/encyclopediaEdit",
            component: encyclopediaEdit,
            meta: {
              title: "内容编辑",
            },
          },
        ],
      },
      // 通用标签
      {
        path: "/commonLabel",
        name: "/commonLabel",
        redirect: "/commonLabel/group",
        component: commonLabel,
        meta: {
          title: "标签管理",
          isMenu: false,
        },
        children: [
          {
            path: "/commonLabel/group",
            name: "labelGroup",
            component: labelGroup,
            meta: {
              title: "通用标签",
            },
          },
          {
            path: "/commonLabels/:id",
            component: firstLabel,
            name: "labelGroupRep",
            meta: {
              title: "通用标签",
              // upMenuTitle: [{title: '通用标签', url: '/commonLabel/group'}, {title: '一级通用标签', url: '/commonLabels/1'}],
            },
          },
        ],
      },
      // 专业问答管理
      {
        path: "/pgc",
        name: "/pgc",
        redirect: "/pgc/qa",
        component: pgcManage,
        meta: {
          title: "专业问答管理",
          isMenu: false,
        },
        children: [
          {
            path: "/pgc/qa",
            name: "/pgc/qa",
            component: pgcQa,
            meta: {
              title: "专业问答",
              isMenu: false,
            },
          },
          {
            path: "/pgc/qaDetail",
            name: "/pgc/qaDetail",
            component: pgcQaDetail,
            meta: {
              title: "专业问答详情",
              isMenu: false,
            },
          },
          {
            path: "/pgc/editQas",
            name: "/pgc/editQas",
            component: editQas,
            meta: {
              title: "编辑专业问答",
              isMenu: false,
            },
          },
          {
            path: "/pgc/import",
            name: "/pgc/import",
            component: pgcImport,
            meta: {
              title: "批量导入问答",
              isMenu: false,
            },
          },
          {
            path: "/pgc/export",
            name: "/pgc/export",
            component: pgcExport,
            meta: {
              title: "批量导出问答",
              isMenu: false,
            },
          },
          {
            path: "/pgc/delete",
            name: "/pgc/delete",
            component: pgcDelete,
            meta: {
              title: "批量导出问答",
              isMenu: false,
            },
          },
          {
            path: "/pgc/record",
            name: "/pgc/record",
            component: pgcRecord,
            meta: {
              title: "操作记录查询",
              isMenu: false,
            },
          },
        ],
      },
      // 谣言
      {
        path: "/rumor/manage",
        name: "/rumormanage",
        redirect: "/rumor/list",
        component: rumorManage,
        meta: {
          title: "谣言管理",
          isMenu: false,
        },
        children: [
          {
            path: "/rumor/list",
            component: rumorList,
            name: "rumorlist",
            meta: {
              title: "谣言列表",
            },
          },
        ],
      },
      // 业务自定义标签
      {
        path: "/customLabel",
        name: "/customLabel",
        redirect: "/customLabel/cusGroup",
        component: customLabel,
        meta: {
          title: "业务标签管理",
          isMenu: false,
        },
        children: [
          {
            path: "/customLabel/cusGroup",
            name: "cusGroup",
            component: customerGroup,
            meta: {
              title: "业务标签",
            },
            children: [],
          },
          {
            path: "/customLabels/:id",
            component: cusFirst,
            name: "cusGroupRep",
            meta: {
              title: "业务标签",
              // upMenuTitle: [{title: '通用标签', url: '/commonLabel/group'}, {title: '一级通用标签', url: '/commonLabels/1'}],
            },
          },
        ],
      },

      // 部位标签
      {
        path: "/partLabel",
        name: "/partLabel",
        redirect: "/partLabel/partGroup",
        component: partLabel,
        meta: {
          title: "内容管理",
          isMenu: false,
        },
        children: [
          {
            path: "/partLabel/partGroup",
            name: "partLabel",
            component: partGroup,
            meta: {
              title: "症状部位",
            },
            children: [],
          },
          {
            path: "/contentDistribution",
            name: "contentDistribution",
            component: contentDistribution,
            meta: {
              title: "内容分发",
            },
            children: [],
          },
          {
            path: "/businessPage",
            name: "BusinessPage",
            component: BusinessPage,
            meta: {
              title: "业务内容",
            },
            children: [],
          },
          {
            path: "/contentDistribution/articles",
            name: "contentDistributionArticle",
            component: contentDistributionArticle,
            meta: {
              title: "查看文章",
            },
            children: [],
          },
        ],
      },

      // 业务管理
      {
        path: "/businessManage",
        name: "businessManage",
        component: businessManage,
        meta: {
          title: "业务管理",
          upMenuTitle: [{ title: "业务配置", url: "", isMenu: false }],
        },
      },
      {
        path: "/categoryManage",
        name: "/categoryManage",
        redirect: "/categoryManage/category",
        component: categoryManage,
        meta: {
          title: "业务配置",
          isMenu: false,
        },
        children: [
          // 栏目管理
          {
            path: "/categoryManage/category",
            name: "category",
            component: category,
            meta: {
              title: "栏目管理",
            },
            children: [],
          },
          {
            path: "/categoryManage/channels",
            name: "channels",
            component: channels,
            meta: {
              title: "频道管理",
              upMenuTitle: [
                { title: "栏目管理", url: "/categoryManage/category" },
              ],
            },
          },
        ],
      },
      //业务账号审核
      {
        path: "/manAudit",
        name: "manAudit",
        component: manAudit,
        meta: {
          title: "业务账号审核",
          upMenuTitle: [{ title: "账号审核", url: "", isMenu: false }],
          keepAlive: false, // 不需要缓存
        },
      },

      //创作者审核
      {
        path: "/userAudit",
        name: "userAudit",
        component: userAudit,
        meta: {
          title: "创作者审核",
          upMenuTitle: [{ title: "账号审核", url: "", isMenu: false }],
          keepAlive: false, // 不需要缓存
        },
      },
      //搬运账号审核
      {
        path: "/carryAccountAudit",
        name: "carryAccountAudit",
        component: carryAudit,
        meta: {
          title: "搬运账号审核",
          upMenuTitle: [{ title: "账号审核", url: "", isMenu: false }],
          keepAlive: false, // 不需要缓存
        },
      },

      // 角色管理
      {
        path: "/roleManage",
        name: "roleManage",
        component: roleManage,
        meta: {
          title: "角色管理",
          keepAlive: false, // 不需要缓存
        },
      },

      // 权限申请
      {
        path: "/authorityApply",
        name: "authorityApply",
        component: authorityApply,
        meta: {
          title: "权限申请",
          keepAlive: false, // 不需要缓存
        },
      },
      // 评价管理
      {
        path: "/evaluation",
        name: "evaluation",
        component: emptyRouter,
        redirect: "/evaluation/evaluation",
        meta: {
          title: "文章评论",
          keepAlive: false, // 不需要缓存
        },
        children: [
          {
            path: "/evaluation/evaluation",
            name: "/evaluation/evaluation",
            component: evaluation,
            meta: {
              title: "文章评论",
            },
          },
          {
            path: "/evaluation/doctorAutoReply",
            name: "/evaluation/doctorAutoReply",
            component: doctorAutoReply,
            meta: {
              title: "医生自动回复",
            },
          },
        ],
      },
      {
        path: "/questionAnswer",
        name: "/questionAnswer",
        component: emptyRouter,
        redirect: "/questionAnswer/questionList",
        meta: {
          title: "问答管理",
          isMenu: false,
        },
        children: [
          {
            path: "/questionAnswer/questionList",
            name: "/questionAnswer/questionList",
            component: questionList,
            meta: {
              title: "问题审核与上下线",
            },
          },
          {
            path: "/questionAnswer/questionEdit",
            name: "/questionAnswer/questionEdit",
            component: questionEdit,
            meta: {
              title: "问题编辑",
            },
          },
          {
            path: "/questionAnswer/answerList",
            name: "/questionAnswer/answerList",
            component: answerList,
            meta: {
              title: "回答审核与上下线",
            },
          },
          {
            path: "/questionAnswer/answerEdit",
            name: "/questionAnswer/answerEdit",
            component: answerEdit,
            meta: {
              title: "回答编辑",
            },
          },
        ],
      },
      // 直播管理
      {
        path: "/liveManage",
        name: "liveManage",
        redirect: "/liveManage/medicalCenter",
        component: liveManage,
        meta: {
          title: "直播管理",
          keepAlive: true, // 不需要缓存
        },
        children: [
          {
            path: "/liveManage/liveList",
            name: "liveManage/liveList",
            component: liveList,
            meta: {
              title: "直播列表",
            },
          },
        ],
      },
      // 内容工具
      {
        path: "/contentTool",
        name: "contentTool",
        redirect: "/contentTool/contentRepeat",
        component: contentTool,
        meta: {
          title: "内容工具",
          keepAlive: true, // 不需要缓存
        },
        children: [
          {
            path: "/contentTool/contentRepeat",
            name: "contentTool/contentRepeat",
            component: contentRepeat,
            meta: {
              title: "内容查重",
            },
          },
          {
            path: "/contentTool/contentRecord",
            name: "contentTool/contentRecord",
            component: contentRecord,
            meta: {
              title: "查重结果",
            },
          },
          {
            path: "/contentTool/contentRepeatDetail",
            name: "contentTool/contentRepeatDetail",
            component: contentRepeatDetail,
            meta: {
              title: "内容查重",
            },
          },
          {
            path: "/contentTool/contentRepeat",
            name: "contentTool/contentRepeat",
            component: contentRepeat,
            meta: {
              title: "内容查重",
            },
          },
          {
            path: "/contentTool/contentSensitiveWord",
            name: "contentTool/contentSensitiveWord",
            component: contentSensitiveWord,
            meta: {
              title: "敏感词限制",
            },
          },
        ],
      },
      {
        path: "/messageManage",
        name: "/messageManage",
        component: messageManage,
        meta: {
          title: "私信管理",
          upMenuTitle: [{ title: "私信管理", url: "", isMenu: false }],
        },
      },
    ],
  },

  // 登录界面
  {
    path: "/index",
    name: "index",
    component: index,
    meta: {
      title: "首页",
    },
  },
  {
    path: "/logo",
    name: "logo",
    component: logo,
    meta: {
      title: "登录",
    },
  },
  // {
  //   path: "*",
  //   redirect: "/error",
  // }, //路由按顺序从上到下，依次匹配。最后一个*能匹配全部，然后重定向到主页面
];

// eslint-disable-next-line no-undef
let router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});
router.beforeEach((to, from, next) => {
  // 判断touter.app是否为null 否则man端浏览器后退报错
  if (!router.app) {
    return;
  }
  if (!to.query?.tenantid && to.query?.tenantid == "") {
    window.location.href = "/index?tenantid=287";
    return;
  }
  if (to.matched.length == 0) {
    next({
      path: "/index",
      query: {
        ...to.query,
        tenantid: commonJs.getTenantId(),
      },
    });
    return;
  }
  if (
    to.path != "/logo" &&
    to.query.tenantid === undefined &&
    to.query.tenantId === undefined
  ) {
    next({
      path: to.path,
      query: {
        ...to.query,
        tenantid: commonJs.getTenantId(),
      },
    });
  } else {
    next();
  }
});
window.dsRouter = router;

export default router;
export { routes };
